// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as FileBDefault } from '../../../assets/icons/default/files/file-b.svg?react';
import { ReactComponent as FileBSolid } from '../../../assets/icons/solid/files/FILE-B.svg?react';
import { createIcons } from '../../Icon';
const FileBIcon = /* @__PURE__ */ createIcons('FileB', {
    default: FileBDefault,
    solid: FileBSolid
});
FileBIcon.supportedTypes = ['default', 'solid'];
FileBIcon.category = 'files';
export default FileBIcon;
